package team.platforma.chatdata.table

import app.cash.sqldelight.Query
import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlCursor
import app.cash.sqldelight.db.SqlDriver
import kotlin.Any
import kotlin.Long
import kotlin.String

public class DraftQueries(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver) {
  public fun <T : Any> selectAll(mapper: (
    draftID: Long,
    aiModelID: Long,
    userID: Long,
    chatID: Long,
    text: String,
  ) -> T): Query<T> = Query(856_687_389, arrayOf("Draft"), driver, "Draft.sq", "selectAll",
      "SELECT Draft.draftID, Draft.aiModelID, Draft.userID, Draft.chatID, Draft.text FROM Draft") {
      cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!
    )
  }

  public fun selectAll(): Query<Draft> = selectAll { draftID, aiModelID, userID, chatID, text ->
    Draft(
      draftID,
      aiModelID,
      userID,
      chatID,
      text
    )
  }

  public fun <T : Any> selectByModelUser(
    aiModelID: Long,
    userID: Long,
    chatID: Long,
    mapper: (
      draftID: Long,
      aiModelID: Long,
      userID: Long,
      chatID: Long,
      text: String,
    ) -> T,
  ): Query<T> = SelectByModelUserQuery(aiModelID, userID, chatID) { cursor ->
    mapper(
      cursor.getLong(0)!!,
      cursor.getLong(1)!!,
      cursor.getLong(2)!!,
      cursor.getLong(3)!!,
      cursor.getString(4)!!
    )
  }

  public fun selectByModelUser(
    aiModelID: Long,
    userID: Long,
    chatID: Long,
  ): Query<Draft> = selectByModelUser(aiModelID, userID, chatID) { draftID, aiModelID_, userID_,
      chatID_, text ->
    Draft(
      draftID,
      aiModelID_,
      userID_,
      chatID_,
      text
    )
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun insertDraft(
    aiModelID: Long,
    userID: Long,
    chatID: Long,
    text: String,
  ): Long {
    val result = driver.execute(-1_672_801_152, """
        |INSERT INTO Draft (aiModelID, userID, chatID, text)
        |VALUES (?, ?, ?, ?)
        """.trimMargin(), 4) {
          bindLong(0, aiModelID)
          bindLong(1, userID)
          bindLong(2, chatID)
          bindString(3, text)
        }.await()
    notifyQueries(-1_672_801_152) { emit ->
      emit("Draft")
    }
    return result
  }

  /**
   * @return The number of rows updated.
   */
  public suspend fun updateDraft(
    text: String,
    chatID: Long,
    draftID: Long,
  ): Long {
    val result = driver.execute(-2_143_098_768, """
        |UPDATE Draft
        |SET text = ?, chatID = ?
        |WHERE draftID = ?
        """.trimMargin(), 3) {
          bindString(0, text)
          bindLong(1, chatID)
          bindLong(2, draftID)
        }.await()
    notifyQueries(-2_143_098_768) { emit ->
      emit("Draft")
    }
    return result
  }

  private inner class SelectByModelUserQuery<out T : Any>(
    public val aiModelID: Long,
    public val userID: Long,
    public val chatID: Long,
    mapper: (SqlCursor) -> T,
  ) : Query<T>(mapper) {
    override fun addListener(listener: Query.Listener) {
      driver.addListener("Draft", listener = listener)
    }

    override fun removeListener(listener: Query.Listener) {
      driver.removeListener("Draft", listener = listener)
    }

    override fun <R> execute(mapper: (SqlCursor) -> QueryResult<R>): QueryResult<R> =
        driver.executeQuery(729_346_425, """
    |SELECT Draft.draftID, Draft.aiModelID, Draft.userID, Draft.chatID, Draft.text
    |FROM Draft
    |WHERE aiModelID = ? AND userID = ? AND chatID = ?
    """.trimMargin(), mapper, 3) {
      bindLong(0, aiModelID)
      bindLong(1, userID)
      bindLong(2, chatID)
    }

    override fun toString(): String = "Draft.sq:selectByModelUser"
  }
}
